import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Server,
  Layers,
  KeyRound,
  TrendingUp,
  FileText,
  Bell,
  Settings,
  LogOut,
  ServerCog
} from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import clsx from 'clsx';

const NAV = [
  { to: '/', label: 'Overview', icon: LayoutDashboard, end: true },
  { to: '/nodes', label: 'Nodes', icon: Server },
  { to: '/groups', label: 'Groups', icon: Layers },
  { to: '/tokens', label: 'Provisioning', icon: KeyRound },
  { to: '/earnings', label: 'Earnings', icon: TrendingUp },
  { to: '/statements', label: 'Statements', icon: FileText },
  { to: '/alerts', label: 'Alerts', icon: Bell },
  { to: '/settings', label: 'Settings', icon: Settings }
];

export function MainLayout() {
  const navigate = useNavigate();
  const operator = useAuthStore(s => s.operator);
  const clear = useAuthStore(s => s.clear);

  const logout = () => {
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex min-h-screen bg-nurev-bg">
      <aside className="flex w-60 flex-col border-r border-nurev-border bg-nurev-surface px-4 py-6">
        <div className="mb-8 flex items-center gap-3 px-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-emerald-400 to-cyan-500 shadow-lg shadow-emerald-500/30">
            <ServerCog className="h-4 w-4 text-white" />
          </div>
          <div>
            <div className="text-sm font-bold tracking-wide text-nurev-text">
              NUREV
            </div>
            <div className="text-[10px] uppercase tracking-widest text-nurev-muted">
              Fleet Console
            </div>
          </div>
        </div>

        <nav className="flex-1 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition',
                  isActive
                    ? 'bg-emerald-500/10 text-emerald-300 ring-1 ring-emerald-500/30'
                    : 'text-nurev-text-soft hover:bg-nurev-surface-lift hover:text-nurev-text'
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 border-t border-nurev-border pt-4">
          {operator && (
            <div className="mb-2 px-3 text-xs">
              <div className="font-medium text-nurev-text">{operator.name}</div>
              <div className="truncate text-nurev-muted">{operator.email}</div>
              {operator.companyName && (
                <div className="mt-0.5 truncate text-nurev-muted">
                  {operator.companyName}
                </div>
              )}
            </div>
          )}
          <button onClick={logout} className="btn-ghost w-full justify-start">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-7xl px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
